const analyticsGlobalParam = '___$SCP_ANALYTICS_OBJECT___';

interface ShowcaseAnalytics {
  pageView: (customTitle?: string) => void;
  trackEvent: (event: string, params: any) => void;
}

interface customWindow extends Window {
  [analyticsGlobalParam]: ShowcaseAnalytics;
}

declare const window: customWindow;

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const _global = window || global;

export const _internalSetupAnalytics = (
  showcaseAnalytics: ShowcaseAnalytics,
): void => {
  _global[analyticsGlobalParam] = showcaseAnalytics;
};

export const analytics = (): ShowcaseAnalytics => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!_global[analyticsGlobalParam]) {
    throw new Error(
      'Analytics is not initialized or you tried to use analytics outside of showcase!',
    );
  }
  return _global[analyticsGlobalParam];
};
